module.exports = __webpack_public_path__ + "img/ETpet.3fe5a946.svg";